export const getPageNumberAfterDelete = (
  currentPage: number,
  perPage: number,
  totalCount: number,
) => {
  const lastPage = Math.ceil(totalCount / perPage);
  if (lastPage === currentPage) {
    return (totalCount - 1) % perPage === 0 ? currentPage - 1 || 1 : currentPage;
  } else {
    return currentPage;
  }
};
